export function truncate(str, truncateLength=14) {
    if (str === undefined || str === null) {
        return '';
    }
    let x = str.length > truncateLength? str.substring(0, truncateLength) + '...' : str;
    return x.trim();
}

